import { Button, Modal, ModalActions } from '@braskai/ui-kit';

import { useInterfaceLanguage } from '@/shared/i18n';
import { ModalHeaderDefault } from '@/shared/ui/modal';

type DiscardChangesModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onDiscard: () => void;
};

export const DiscardChangesModal = ({ isOpen, onCancel, onDiscard }: DiscardChangesModalProps) => {
  const { t } = useInterfaceLanguage();

  return (
    <Modal open={isOpen} size="xs" onClose={onCancel}>
      <ModalHeaderDefault
        title={t('teamspace.discard.title')}
        subtitle={t('teamspace.discard.subtitle')}
        onClose={onCancel}
      />

      <ModalActions>
        <Button data-testid="teamspace-cancel-discard-changes" variant="outlined" fullWidth onClick={onCancel}>
          {t('teamspace.action.cancel')}
        </Button>
        <Button data-testid="teamspace-confirm-discard-changes" variant="error" fullWidth onClick={onDiscard}>
          {t('teamspace.action.discardChanges')}
        </Button>
      </ModalActions>
    </Modal>
  );
};
